
import React from 'react';
import { useNavigate } from 'react-router-dom';
import USColoredMap from "../locations/USColoredMap";
import { locationsData } from "../../data/locationsData";

const LocationsSection = ({ onClickState }) => {
  const navigate = useNavigate();
  const servicedStates = locationsData.map(loc => ({
    title: loc.title,
    id: loc.id
  }));

  return (
    <section className="bg-gray-100">
      <div className="container max-w-4xl mx-auto px-4 flex flex-col items-center">
        <h2 className="text-3xl font-bold text-center text-gray-800 mt-10 mb-6">USA Traffic Control Locations</h2>
        <div className="w-full flex flex-wrap justify-center gap-4 py-4">
          {servicedStates.map((state) => (
            <button 
              key={state.id}
              onClick={() => {
                navigate(`/locations#${state.id}`);
              }}
              className="flex items-center gap-2 bg-orange-100 px-4 py-2 text-orange-700 font-semibold text-sm shadow-sm 
                        transition-all duration-300 hover:scale-105 hover:shadow-md hover:bg-orange-200 active:scale-95"
            >
              <span className="w-2 h-2 bg-orange-500 mr-2" />
              {state.title}
            </button>
          ))}
        </div>
        <div className="w-full max-w-4xl -mt-1">
          <USColoredMap onClickState={onClickState} />
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;
